const APP_NAVIGATION_HIGHLIGHT = /* @__PURE__ */ Symbol("nc:app-navigation-highlight");
export {
  APP_NAVIGATION_HIGHLIGHT as A
};
//# sourceMappingURL=highlight.mjs.map
